export const BULK_INVITE_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const BULK_INVITE_LARGE_BATCH_ROW_WARNING = 500;
export const BULK_INVITE_ALLOWED_FILE_EXTENSIONS = ['.xlsx', '.xls', '.csv'];
export const BULK_INVITE_ALLOWED_MIME_TYPES = new Set([
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv',
  'application/csv',
  'text/plain',
]);

export const getBulkInviteFileValidationError = (file: File): string | null => {
  const lowerName = file.name.toLowerCase();
  const hasValidExtension = BULK_INVITE_ALLOWED_FILE_EXTENSIONS.some((ext) =>
    lowerName.endsWith(ext)
  );

  if (!hasValidExtension) {
    return 'Please select an Excel file (.xlsx, .xls) or CSV file';
  }

  if (file.type && !BULK_INVITE_ALLOWED_MIME_TYPES.has(file.type)) {
    return 'Invalid file type. Please upload .xlsx, .xls, or .csv files';
  }

  if (file.size > BULK_INVITE_MAX_FILE_SIZE_BYTES) {
    return `File size must be less than ${BULK_INVITE_MAX_FILE_SIZE_BYTES / 1024 / 1024}MB`;
  }

  return null;
};
